import { AuthorizedAPI } from 'config';
import { call, put, takeEvery } from 'redux-saga/effects';
import ScanActions from 'redux/ScanRedux';
import { ScanTypes } from 'redux/ScanRedux';
import ApiServices from 'services/API/ApiServices';

export function* onRequestGetScanData({ payload }) {
  const response = yield call(
    ApiServices[payload?.method],
    AuthorizedAPI,
    payload?.slug,
    payload?.data
  );
  if (response?.status === 200) {
    yield put(
      ScanActions.getScanSuccess({
        loader: payload?.loader,
        getScanDetail: response.data?.data
      })
    );
  } else {
    payload.onFailedGetLabelData(response.data.error);
    yield put(
      ScanActions.getScanFailure({
        loader: payload?.loader,
        error: response?.data
      })
    );
  }
}
export default [takeEvery(ScanTypes.GET_SCAN_ACTION, onRequestGetScanData)];
